import { render, staticRenderFns } from "./calendarResourcesList.vue?vue&type=template&id=09d4ede2&"
import script from "./calendarResourcesList.vue?vue&type=script&lang=js&"
export * from "./calendarResourcesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports